// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3Tl5X","filesListContainer":"PosDisputesFiles_filesListContainer__1xnTP","filesButton":"PosDisputesFiles_filesButton__67UVz"};